import Home from "./pages/home/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import About from "./pages/about/About";
import { Helmet } from "react-helmet";
import FaqPage from "./pages/home/FaqPage";
import Products from "./pages/home/Products";
import BusinessSupport from "./pages/home/BusinessSupport";
import Login from "./pages/login/Login";
import SignUp from "./pages/signUp/SignUp";
import Otp from "./components/otherComponents/Otp";
import ForgotPass from "./pages/login/ForgotPass";
import CustomizeAdmin from "./pages/customizeAdmin/CustomizeAdmin";

function App() {
  return (
    //just adding to test deployment
    <div className="app">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Logistat</title>
        <link rel="canonical" href="http://mysite.com/example" />
        <meta name="description" content="Logistat application" />
      </Helmet>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/FaqPage" element={<FaqPage />} />
          <Route path="/products" element={<Products />} />
          <Route path="/otp" element={<Otp />} />
          <Route
            path="/products/businessSupport"
            element={<BusinessSupport />}
          />
          <Route path="/login" element={<Login />} />
          <Route path="/signUp" element={<SignUp />} />
          <Route path="/forgotPass" element={<ForgotPass />} />
          <Route path="/customAdmin" element={<CustomizeAdmin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
